/**
 *
 * @module watchlistQuery
 *
 */

import Check from 'check-types';
import Exception from './../../services/exception/entry';
import ContentQuery from './../contentQuery';
import GraphQlQuery from './../graphQlQuery';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class WatchlistQuery
 * @extends {SDK.Content.ContentQuery}
 *
 */
export default class WatchlistQuery extends ContentQuery {

    /**
     *
     * @param {GraphQlQuery} query
     *
     */
    constructor(query) {

        const errorMessage = {
            ctor: 'WatchlistQuery(query)',
            get query() {
                return `${this.ctor} needs GraphQlQuery instance`;
            }
        };

        instanceStrict(query, GraphQlQuery, errorMessage.query, InvalidArgumentException);

        super('watchlist', query);

    }

}



// WEBPACK FOOTER //
// ./src/content/watchlist/watchlistQuery.js